import { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import OfficerSidebar from './OfficerSidebar';
import OfficerNavbar from './OfficerNavbar';
import { isOfficerContextUser } from '../authStorage';
import './AppLayout.css';

function AppLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const activePage = location.pathname.split('/')[2] || 'dashboard';
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const officerMode = isOfficerContextUser();

  /* close sidebar on route change (mobile) */
  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  useEffect(() => {
    const isAppPath = location.pathname === '/app' || location.pathname.startsWith('/app/');
    const isOfficerPath = location.pathname === '/officer' || location.pathname.startsWith('/officer/');
    if (officerMode && isAppPath) {
      const suffix = location.pathname.slice('/app'.length) || '/dashboard';
      navigate(`/officer${suffix}`, { replace: true });
    } else if (!officerMode && isOfficerPath) {
      const suffix = location.pathname.slice('/officer'.length) || '/dashboard';
      navigate(`/app${suffix}`, { replace: true });
    }
  }, [officerMode, location.pathname, navigate]);

  return (
    <div className="layout">
      {officerMode ? (
        <OfficerSidebar active={activePage} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      ) : (
        <Sidebar active={activePage} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      )}
      {sidebarOpen && <div className="layout__overlay" onClick={() => setSidebarOpen(false)} />}
      <div className="layout__body">
        {officerMode ? (
          <OfficerNavbar activePage={activePage} onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        ) : (
          <Navbar activePage={activePage} onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        )}
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
